import { useIsVivaEngageRebranding } from './useIsVivaEngageRebranding';

type UseGetProductName = () => string;
export const useGetProductName: UseGetProductName = () => {
  const isVivaEngageRebranding = useIsVivaEngageRebranding();

  return isVivaEngageRebranding ? 'Viva Engage' : 'Yammer';
};
